import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, take } from 'rxjs';
import { AuthenticationService } from './authentication.service';

export function EntryGuard(): Observable<boolean> {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  
  // If on login route, always allow (let login component handle it)
  if (router.url.startsWith('/login')) {
    return of(true);
  }
  
  if (!authService.isFirstTimeLogin()) {
    return authService.handleRedirect().pipe(take(1));
  } else {
    return of(true);
  }
}
